import { render, staticRenderFns } from "./DataCircle.vue?vue&type=template&id=8667985c&scoped=true"
import script from "./DataCircle.vue?vue&type=script&lang=js"
export * from "./DataCircle.vue?vue&type=script&lang=js"
import style0 from "./DataCircle.vue?vue&type=style&index=0&id=8667985c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8667985c",
  null
  
)

export default component.exports